import type { BadgeVariant } from '@new/common/ui/Badge/Badge';
import type { EvaluationStatus, TranscriptStatus } from '../types';

const EVALUATION_STATUS_LABELS: Record<EvaluationStatus, string> = {
  empty: 'No transcripts',
  draft: 'Draft',
  in_review: 'Needs review',
  completed: 'Completed',
};

const EVALUATION_STATUS_VARIANTS: Record<EvaluationStatus, BadgeVariant> = {
  empty: 'default',
  draft: 'default',
  in_review: 'yellow',
  completed: 'green',
};

const TRANSCRIPT_STATUS_LABELS: Record<TranscriptStatus, string> = {
  draft: 'Draft',
  in_review: 'In review',
  approved: 'Approved',
  rejected: 'Rejected',
};

const TRANSCRIPT_STATUS_VARIANTS: Record<TranscriptStatus, BadgeVariant> = {
  draft: 'default',
  in_review: 'yellow',
  approved: 'green',
  rejected: 'red',
};

export const getEvaluationStatusLabel = (status: EvaluationStatus): string =>
  EVALUATION_STATUS_LABELS[status];

export const getEvaluationStatusVariant = (status: EvaluationStatus): BadgeVariant =>
  EVALUATION_STATUS_VARIANTS[status];

export const getTranscriptStatusLabel = (status: TranscriptStatus): string =>
  TRANSCRIPT_STATUS_LABELS[status];

export const getTranscriptStatusVariant = (status: TranscriptStatus): BadgeVariant =>
  TRANSCRIPT_STATUS_VARIANTS[status];
